// userAPI.js - API service for user management
import { fetchAPI, fetchWithAuth } from "../apiutil";

export const userAPI = {
  forceLogoutUser: async (accessToken, userId) => {
    console.log("[userAPI.forceLogoutUser] forcing user logout");
    return fetchAPI(`/api/logout/${userId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  loadUser: async (accessToken, userId) => {
    console.log("[userAPI.loadUser] loading user:", userId);
    return fetchWithAuth(`/api/user/${userId}`, { method: "GET" }, accessToken);
  },

  deleteUser: async (accessToken, userId, clipsOnly = false) => {
    console.log(
      "[userAPI.deleteUser] deleting user:",
      userId,
      "clipsOnly:",
      clipsOnly
    );
    let url = `/api/user/${userId}`;
    if (clipsOnly) url += "/clips";

    return fetchWithAuth(url, { method: "DELETE" }, accessToken);
  },

  saveUser: async (accessToken, userData) => {
    console.log("[userAPI.saveUser] saving user:", userData);
    return fetchWithAuth(
      "/api/user",
      {
        method: "POST",
        body: JSON.stringify(userData),
      },
      accessToken
    );
  },
};
